import React from 'react'

export default function Unauthorised() {
  return (
    <div>
      <h1>Unauthorised</h1>
    </div>
  )
}
